<template>
    <v-flex>
        <upcoming-event v-if="isVisible"></upcoming-event>
        <chapter-list v-if="isVisible"></chapter-list>
        <region-map v-if="isVisible"></region-map>
        <chapter-event-right-sidebar class="panelBlock" v-if="isVisible"></chapter-event-right-sidebar>
        <community-officers-list class="panelBlock" v-if="isVisible"></community-officers-list>
        <Announcement></Announcement>
    </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
import { appCommonConstants } from '../appCommon.constants';
import CommunityOfficersList from '../CommunityOfficersList/CommunityOfficersList';
import UpcomingEvent from '@/components/ChapterPage/UpcomingEvents/UpcomingEvent';
import { upcomingEventsConstant, communityCommonConstant } from '@/components/ChapterPage/communityCommon.constant';
import Announcement from './Announcement/Announcement.vue';
import { storeGetters } from '../../store/storeGetters.constant';
import RegionMap from '../RegionPage/RegionMap.vue';
import ChapterList from '../RegionPage/ChapterList.vue';
import ChapterEventRightSidebar from '@/components/ChapterEvent/ChapterEventRightSideBar';

export default {
    name: 'ChapterRightSidebar',
    components: {
        CommunityOfficersList,
        UpcomingEvent,
        Announcement,
        ChapterEventRightSidebar,
        ChapterList,
        RegionMap
    },
    data() {
        return {
            dialogState: {
                isVisible: false,
            },
            upcomingEventsConstant,
            appCommonConstants,
            communityCommonConstant,
        };
    },
    computed: {
        ...mapGetters({
            userCommunityList: `chapter/${storeGetters.usersCommunitiesList}`,
            allChapterList: `chapter/${storeGetters.allChapterList}`,
        }),
        isVisible() {
            if(this.allChapterList){
                return this.$route.params.communityId && this.userCommunityList;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';

.time_block {
    margin: 20px 10px 10px 10px;
    padding: 10px 5px;
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba($black, 0.18);
    border: 1px solid rgba($ypo-gray, 0.4);

    .date {
        color: $ypo-dark-background-gray;
        line-height: 12px;
        padding-left: 5px;

        span {
            font-size: 12px;
            display: block;
            font-weight: 600;
            line-height: normal;
        }

        strong {
            color: $ypo_blue;
            font-family: 'Noto Sans';
            font-size: 28px;
            display: block;
            line-height: normal;
            padding: 4px 0;
            font-weight: 400;
        }

        small {
            color: $ypo-dark-background-gray;
            font-size: 10px;
            font-weight: bold;
        }
    }

    .desc {
        color: $ypo_blue;
        font-family: 'Noto Sans';
        font-size: 12px;
        font-weight: bold;
        letter-spacing: -0.15px;
        line-height: 17px;
        margin-bottom: 30px;
    }

    .v-avatar {
        border: 1px solid $ypo-medium-gray;
    }

    .member__deatils {
        span {
            color: $ypo-dark-background-gray;
            font-size: 12px;
            letter-spacing: -0.15px;
            line-height: 15px;
            padding-left: 5px;
        }

        .v-btn {
            width: auto;
            height: auto;
            color: $ypo-dark-background-gray;
            font-size: 12px;
            letter-spacing: 0.4px;
            line-height: 16px;
            text-align: right;

            &:hover {
                &:before {
                    background-color: transparent;
                }

                &:active {
                    background-color: transparent;
                }
            }

            &:focus {
                background-color: transparent;
            }
        }
    }

    .action-btns {
        border-top: 1px solid $ypo-medium-gray;
        margin-top: 10px;
        padding-top: 5px;
        text-align: center;

        .v-btn {
            padding: 0;
            text-transform: capitalize;
            min-width: auto;
            background: transparent !important;
            box-shadow: none !important;
            height: auto;
            color: $ypo-dark-background-gray;
            font-size: 12px;
            margin: 0;

            &.active {
                color: $ypo-green;

                i {
                    color: $ypo-green;
                    margin-top: 0;
                    font-size: 14px;
                    margin-right: 3px;
                }
            }

            &:hover {
                &:before {
                    background-color: transparent;
                }

                &:active {
                    background-color: transparent;
                }
            }

            &:focus {
                background-color: transparent;
            }
        }

        i {
            font-size: 20px;
            color: $ypo-cta;
            margin-top: 5px;
            cursor: pointer;
        }
    }
}

.rec_events {
    .v-card {
        margin: 10px;
        border: 1px solid rgba($ypo-gray, 0.2);
        border-radius: 4px;
        background-color: rgba($ypo-gray, 0.1);
        box-shadow: none;
        min-height: 230px;
        font-size: 12px;

        span {
            color: $ypo-blue;
        }

        .headline {
            color: $white;
            position: relative;
            font-size: 16px !important;
            left: 10px;
            top: 5px;
        }
    }

    .image-overlay {
        &:before {
            background: linear-gradient(0deg, rgba($black, 0) 0%, $black 100%);
            content: '';
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            position: absolute;
        }
    }

    .fill-height {
        padding: 0;

        .v-icon {
            font-size: 14px;
            color: $white;
            position: absolute;
            right: 5px;
            top: 5px;
            cursor: pointer;
            opacity: 0.3;
        }
    }

    .v-card__title {
        min-height: 100px;
        align-items: flex-start;
    }
}
</style>
